import { Badge, Tabs, TabsProps } from "antd";
import { observer } from "mobx-react-lite";
import { PendingActionsBids } from "../PendingActionsBids";
import { PendingActionsContracts } from "../PendingActionsContracts";
import { PendingActionsCompanies } from "../PendingActionsCompanies";
import { USER_SCOPE_ENUM, UserScope } from "interfaces";
import { useStores } from "stores";

import styles from "./tabs.module.css";

type PendingTabsProps = Required<TabsProps>["items"][number] & {
  roles: UserScope[];
};

export enum PENDING_TABS {
  BIDS = "requests",
  CONTRACTS = "contracts",
  COMPANIES = "companies",
}

const items: PendingTabsProps[] = [
  {
    key: PENDING_TABS.BIDS,
    label: "Заявки",
    children: <PendingActionsBids />,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_CUSTOMER,
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.RISK_MANAGER,
      USER_SCOPE_ENUM.JUNIOR_LP,
      USER_SCOPE_ENUM.SENIOR_LP,
      USER_SCOPE_ENUM.LP_RISK_MANAGER,
    ],
  },
  {
    key: PENDING_TABS.CONTRACTS,
    label: "Договоры",
    children: <PendingActionsContracts />,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_CUSTOMER,
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.RISK_MANAGER,
    ],
  },
  {
    key: PENDING_TABS.COMPANIES,
    label: "Компании",
    children: <PendingActionsCompanies />,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.RISK_MANAGER,
      USER_SCOPE_ENUM.USER_ADMIN,
    ],
  },
];

export const EntityTypeTabs = observer(() => {
  const { pendingStatistics, user } = useStores();

  const tabItems = items
    .filter((item) => item.roles.some((role) => user.scope.includes(role)))
    .map((item) => {
      const indicators = pendingStatistics?.indicators?.[item.key as keyof typeof pendingStatistics.indicators];
      const hasPendingItems = indicators && Object.values(indicators).some((value) => value > 0);

      return {
        ...item,
        label: (
          <Badge
            dot={!!hasPendingItems}
            offset={[5, 5]}
            color="green"
            id={item.key === PENDING_TABS.BIDS ? "pending-actions-bids-tab" : undefined}
          >
            {item.label}
          </Badge>
        ),
      };
    });

  return <Tabs items={tabItems} defaultActiveKey={PENDING_TABS.BIDS} destroyInactiveTabPane className={styles.tabs} />;
});
